<template>
  <!-- 最顶部title -->
  <div class="liu pos-manage">
    <!-- 页面主体 -->
    <div class="scroll-container current-padding-top" :style="customScrollHeight">
      <!-- 上部tab菜单 -->
      <div class="tab-menu">
        <div class="tab-menu-item current-tab" :class="{'selected': tabStatus.selected[0], 'complete': tabStatus.completed[0]}" @click="onTabClick(0)">
          <span>基本信息</span>
        </div>
        <div class="tab-menu-item current-tab" :class="{'selected': tabStatus.selected[1], 'complete': tabStatus.completed[1]}" @click="onTabClick(1)">
          <span>结算卡信息</span>
        </div>
        <div class="tab-menu-item current-tab" :class="{'selected': tabStatus.selected[2], 'complete': tabStatus.completed[2]}" @click="onTabClick(2)">
          <span>注册信息</span>
        </div>
      </div>
      <!-- 基本信息-主体 -->
      <div id="tabItem0" v-show="currentTabIndex === 0">
        <div class="form mt-53">
          <!-- 代理商名称 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.agentName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="baseData.agentName.value" :placeholder="baseData.agentName.placeholder">
              </div>
            </div>
          </div>
          <!-- 手机号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.agentMobile.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="baseData.agentMobile.value" maxlength="13" :placeholder="baseData.agentMobile.placeholder" @keyup="onAgentMobileInput">
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 证件照 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>法人</span>
                <br>
                <span>证件照</span>
              </div>
              <div class="content ">
                <div class="id-picture">
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('renXiang')">
                      <img v-if="baseData.idCardFront.value" :src="baseData.idCardFront.value" alt="">
                      <svg-icon v-else icon-class="authenticate-headshot" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ baseData.idCardFront.label }}</span>
                    </div>
                  </div>
                  <div class="picture-item">
                    <div class="picture-item-img" @click="$refs.camera.imgClick('guoHui')">
                      <img v-if="baseData.idCardBack.value" :src="baseData.idCardBack.value" alt="">
                      <svg-icon v-else icon-class="authenticate-emblem" class-name="item-svg"></svg-icon>
                    </div>
                    <div class="picture-item-label">
                      <span>{{ baseData.idCardBack.label }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 法人姓名 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.idCardName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="baseData.idCardName.value" maxlength="15" :placeholder="baseData.idCardName.placeholder">
              </div>
            </div>
          </div>
          <!-- 法人身份证号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.idCardNo.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="baseData.idCardNo.value" maxlength="20" :placeholder="baseData.idCardNo.placeholder" @keyup="onIdCardNoInput">
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 营业执照 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.businessLicense.label }}</span>
              </div>
              <div class="content">
                <div class="picture" @click="$refs.camera.imgClick('businessLicense')">
                  <svg-icon v-if="!baseData.businessLicense.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="baseData.businessLicense.value" alt="">
                </div>
              </div>
            </div>
          </div>
          <!-- 营业执照号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.businessLicenseNo.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="baseData.businessLicenseNo.value" maxlength="18" :placeholder="baseData.businessLicenseNo.placeholder" @keyup="onBusinessLicenseNoInput">
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 所在省份 -->
          <div class="row" @click="onBaseProvinceCItyClick">
            <div class="item">
              <div class="label">
                <span>{{ baseData.baseProvince.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':baseData.baseProvince.value!=='请选择'}">
                <span>{{ baseData.baseProvince.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 所在城市 -->
          <div class="row" @click="onBaseProvinceCItyClick">
            <div class="item">
              <div class="label">
                <span>{{ baseData.baseCity.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':baseData.baseCity.value!=='请选择'}">
                <span>{{ baseData.baseCity.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 联系地址 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.baseAddress.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="baseData.baseAddress.value" :placeholder="baseData.baseAddress.placeholder">
              </div>
            </div>
          </div>
          <!-- 税务登记号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.taxRegisterNo.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="baseData.taxRegisterNo.value" :placeholder="baseData.taxRegisterNo.placeholder">
              </div>
            </div>
          </div>
          <!-- 电子邮箱 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ baseData.baseEmail.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="baseData.baseEmail.value" :placeholder="baseData.baseEmail.placeholder">
              </div>
            </div>
          </div>
          <!-- 昵称 -->
          <div class="row" @click="onPetNameClick" v-if="false">
            <div class="item">
              <div class="label">
                <span>{{ baseData.petName.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':baseData.petName.value!=='请选择'}">
                <span>{{ baseData.petName.value }}</span>
                <div class="arrow" v-show="baseData.petName.mult" />
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onBaseInfoSubmitClick">
            下一步
          </mt-button>
        </div>
      </div>
      <!-- 账户信息-主体 -->
      <div id="tabItem1" v-show="currentTabIndex === 1">
        <div class="form mt-53">
          <!-- 开户类型 -->
          <div class="row" @click="onAccountTypeClick">
            <div class="item">
              <div class="label">
                <span>{{ accountData.accountType.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':accountData.accountType.value!=='请选择'}">
                <span>{{ accountData.accountType.value }}</span>
                <div class="arrow" v-show="accountData.accountType.mult" />
              </div>
            </div>
          </div>
          <!-- 开户姓名 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ accountData.accountName.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="accountData.accountName.value" maxlength="15" :placeholder="accountData.accountName.placeholder">
              </div>
            </div>
          </div>
          <!-- 银行卡号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ accountData.accountNo.label }}</span>
              </div>
              <div class="content">
                <input type="text" v-model="accountData.accountNo.value" maxlength="24" :placeholder="accountData.accountNo.placeholder" @keyup="onAccountNoInput">
              </div>
            </div>
          </div>
          <!-- 所属银行 -->
          <div class="row" @click="onBankNameClick">
            <div class="item">
              <div class="label">
                <span>{{ accountData.bankName.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':accountData.bankName.value!=='请选择'}">
                <span>{{ accountData.bankName.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 开户地区 -->
          <div class="row" @click="onBankAreaClick">
            <div class="item">
              <div class="label">
                <span>{{ accountData.bankArea.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':accountData.bankArea.value!=='请选择'}">
                <span>{{ accountData.bankArea.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
          <!-- 开户行 -->
          <div class="row" @click="onBankSubNameClick">
            <div class="item">
              <div class="label">
                <span>{{ accountData.bankSubName.label }}</span>
              </div>
              <div class="content sheet" :class="{'selected':accountData.bankSubName.value!=='请选择'}">
                <span>{{ accountData.bankSubName.value }}</span>
                <div class="arrow" />
              </div>
            </div>
          </div>
        </div>
        <div class="form mt-15">
          <!-- 开户许可证 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ accountData.accountLicense.label }}</span>
              </div>
              <div class="content">
                <div class="picture" @click="$refs.camera.imgClick('accountLicense')">
                  <svg-icon v-if="!accountData.accountLicense.value" icon-class="camera_comm" class-name="svg" />
                  <img v-else :src="accountData.accountLicense.value" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onAccountInfoSubmitClick">
            下一步
          </mt-button>
        </div>
      </div>
      <!-- 注册信息-主体 -->
      <div id="tabItem3" v-show="currentTabIndex === 2">
        <div class="form mt-53">
          <!-- 登录账号 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ registerData.loginNumber.label }}</span>
              </div>
              <div class="content">
                <!-- <input type="text" v-model="registerData.loginNumber.value" maxlength="13" :placeholder="registerData.loginNumber.placeholder" @keyup="onLoginNumberInput"> -->
                <span> {{ registerData.loginNumber.value }} </span>
              </div>
            </div>
          </div>
          <!-- 验证码 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ registerData.verificationCode.label }}</span>
              </div>
              <div class="content">
                <input type="tel" class="short-input" v-model="registerData.verificationCode.value" maxlength="6" :placeholder="registerData.verificationCode.placeholder" @keyup="onVerificationCodeInput">
                <div class='link-btn' :class="{'disabled':tmp.verificationBtnDisabled}" @click="onGetVerificationCodeClick">
                  <span>{{ tmp.verificationBtnText }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 登录密码 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ registerData.registerPassword1.label }}</span>
              </div>
              <div class="content">
                <input :type="tmp.pwd1Type" v-model="registerData.registerPassword1.value" maxlength="30" :placeholder="registerData.registerPassword1.placeholder" @keyup="onRegisterPassword1Input">
                <div class="scan" @click="onPwd1EyeClick">
                  <svg-icon :icon-class="tmp.pwd1Svg" class-name="cur-icon"></svg-icon>
                </div>
              </div>
            </div>
          </div>
          <!-- 再输一次 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ registerData.registerPassword2.label }}</span>
              </div>
              <div class="content">
                <input :type="tmp.pwd2Type" v-model="registerData.registerPassword2.value" maxlength="30" :placeholder="registerData.registerPassword2.placeholder" @keyup="onRegisterPassword2Input">
                <div class="scan" @click="onPwd2EyeClick">
                  <svg-icon :icon-class="tmp.pwd2Svg" class-name="cur-icon"></svg-icon>
                </div>
              </div>
            </div>
          </div>
          <!-- 邀请码 -->
          <div class="row">
            <div class="item">
              <div class="label">
                <span>{{ registerData.invitationCode.label }}</span>
              </div>
              <div class="content">
                <input v-show="!tmp.invitationTextDisabled" type="text" v-model="registerData.invitationCode.value" :placeholder="registerData.invitationCode.placeholder" @keyup="onInvitationCodeInput">
                <span v-show="tmp.invitationTextDisabled"> {{ registerData.invitationCode.value }} </span>
              </div>
            </div>
          </div>
        </div>
        <div class="form">
          <div class="explain inline">
            <div @click="onCheckClick">
              <svg-icon :icon-class="tmp.checkBoxSvg" class-name="cur-icon"></svg-icon>
            </div>
            &nbsp;我已阅读并同意
            <span class="link" @click="onToAgreementClick">《注册协议》</span>
          </div>
        </div>
        <div class="btn">
          <mt-button type="primary" size="large" @click="onRegisterInfoSubmitClick">
            注册
          </mt-button>
        </div>
      </div>
    </div>
    <!-- 页面右侧备选项窗口 -->
    <mt-popup class="agent-popup" v-model="popup.visible" position="right" :modal="false">
      <mt-header fixed :title="popup.title" class="title2">
        <mt-button slot="left" icon="back" @click="onPopupBackBtnClick">返回</mt-button>
      </mt-header>
      <div class="scroll-container" :style="customScrollHeight">
        <!-- 短备选项 -->
        <div class="mt-15" v-if="popup.type===1">
          <!-- 昵称 -->
          <div class="form" v-if="popup.parent==='petName'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.incentiveModelArr" :key="idx" @click="onIncentiveModelItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 开户类型 -->
          <div class="form" v-if="popup.parent==='accountType'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.accountTypeArr" :key="idx" @click="onAccountTypeItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <div class="btn">
            <mt-button type="primary" size="large" @click="onPopupSuccessBtnClick">
              确定
            </mt-button>
          </div>
        </div>
        <!-- 长备选项1 -->
        <mt-search v-if="popup.type===2" v-model="popup.searchKey" cancel-text="取消" placeholder="筛选" :show="true" @keyup.enter.native="onPopupSearchKeyup">
          <!-- 收款资料-银行 -->
          <div class="form" v-if="popup.parent==='bankName'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankNameArr" :key="idx" @click="onPopupBankNameItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款资料-银行地区 -->
          <div class="form" v-if="popup.parent==='bankArea'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankAreaArr" :key="idx" @click="onPopupBankAreaItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" style="right:1.6rem;" />
                  <div class="arrow" />
                </div>
              </div>
            </div>
          </div>
          <!-- 收款资料-银行开户行 -->
          <div class="form" v-if="popup.parent==='bankSubName'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankSubNameArr" :key="idx" @click="onPopupBankSubNameItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
        </mt-search>
        <!-- 长备选项2 -->
        <mt-search v-if="popup.type===3" v-model="popup.searchSubKey" cancel-text="取消" placeholder="筛选" :show="true" @keyup.enter.native="onPopupSearchSubKeyup">
          <!-- 收款资料-银行地区城市 -->
          <div class="form" v-if="popup.parent==='bankAreaProvince'">
            <div class="row" :class="{'selected':item.selected===true}" v-for="(item,idx) in popup.bankAreaCityArr" :key="idx" @click="onPopupBankAreaCityItemClick(item)">
              <div class="item">
                <div class="label">
                  <span>{{ item.label }}</span>
                </div>
                <div class="content">
                  <div class="tick" />
                </div>
              </div>
            </div>
          </div>
        </mt-search>
      </div>
    </mt-popup>
    <!-- 页面下侧省市区窗口 -->
    <mt-popup class="area-popup" v-model="areaPop.visible" position="bottom" :modal="true">
      <mt-picker :slots="areaPop.areaSlots" valueKey="label" :visibleItemCount="5" :showToolbar="true" @change="onAreaPopChange">
        <div class="tool-bar">
          <div class="tool-btn" @click="areaPop.visible=false">
            <span>关闭</span>
          </div>
          <div class="tool-btn" @click="onAreaPopupSuccessClick">
            <span>确定</span>
          </div>
        </div>
      </mt-picker>
    </mt-popup>
    <!-- 注册协议弹出窗口 -->
    <mt-popup class="register-agreement" v-model="agreementPop.visible">
      <div class="container">
        <div class="title">恒信通注册协议</div>
        <div class="content" v-html="hasNameAgreementText"></div>
        <div class="btn current-agreement-btn" @click="agreementPop.visible=false">关闭</div>
      </div>
    </mt-popup>
    <!-- 相机组件 -->
    <camera ref="camera" @getImgInfo="getCameraImgInfo" />
  </div>
</template>

<script>
/* exported PUBLIC_TOKEN */
/* global  PUBLIC_TOKEN */
/* global  PUBLIC_AGREEMENT_TEXT */
/* global  PUBLIC_APP_NAME */
/* global  PUBLIC_WELCOME_QRCODE */
/* global  PUBLIC_PRODUCT */
/* global  PUBLIC_SYSTEM_FLAG */
/* global  android_download_url */
/* global  ios_download_url */

import SvgIcon from '@/components/SvgIcon';
import camera from '@/components/camera';
import { AgentRegister } from '@/api/user';
import { GetTokenByDls, GetConfigByDls, GetSMSCode } from '@/api/interface';
import { GetIdCardInformation, GetBusinessLicenseInfo, GetAreaList, GetAllBankName, GetBankProvinceName, GetBankCityName, GetBankName, GetSBNOByCardNumWithoutLogin } from '@/api/customer';
import { controlIdCardInput, controlMobileInput, controlMoneyInput, controlBankCardInput, controlLicenseNoInput } from '@/utils/format';
import { validateEmpty, validateMobile, validatePassword, validateIdCard, validateLicenseNo2, validateBankCardPublic } from '@/utils/validate';
import { SucceedHandle2, NotSucceedHandle } from '@/api/handle';
import { upLoadImgForAgent } from '@/utils/utils';
import { CusToast, CusConfirm, CusLoadingOpen, CusLoadingClose } from '@/utils/CustomToast';

export default {
  name: 'EnterpriseRegister',
  components: { camera, SvgIcon },
  data() {
    return {
      currentTabIndex: 0,
      isFlowFinish: true,
      tabStatus: {
        selected: [true, false, false],
        edited: [true, false, false],
        completed: [false, false, false],
      },
      baseData: {
        agentName: { label: '代理商名称', value: '', placeholder: '请输入代理商名称' },
        agentMobile: { label: '代理商手机号', value: '', placeholder: '请输入手机号' },
        idCardFront: { label: '头像面', value: '', placeholder: '' },
        idCardBack: { label: '国徽面', value: '', placeholder: '' },
        idCardName: { label: '法人姓名', value: '', sex: '', birthday: '', nationality: '', address: '', office: '', placeholder: '请输入法人姓名' },
        idCardNo: { label: '法人身份证号', value: '', placeholder: '请输入法人身份证号' },
        businessLicense: { label: '营业执照', value: '', placeholder: '' },
        businessLicenseNo: { label: '营业执照号', value: '', placeholder: '请输入营业执照号' },
        taxRegisterNo: { label: '税务登记号(选填)', value: '', placeholder: '请输入税务登记号' },
        baseProvince: { label: '所在省份', value: '请选择', id: '', placeholder: '' },
        baseCity: { label: '所在城市', value: '请选择', id: '', placeholder: '' },
        baseAddress: { label: '联系地址', value: '', placeholder: '请输入联系地址' },
        baseEmail: { label: '电子邮箱(选填)', value: '', placeholder: '请输入电子邮箱' },
        petName: { label: '昵称(选填)', value: '请选择', id: '', placeholder: '', mult: true },
      },
      accountData: {
        accountType: { label: '开户类型', value: '企业', id: 2, placeholder: '', mult: false },
        accountName: { label: '开户名', value: '', placeholder: '请输入开户名' },
        accountNo: { label: '开户行账号', value: '', placeholder: '请输入开户行账号' },
        bankName: { label: '银行名称', value: '请选择', placeholder: '' },
        bankArea: { label: '开户地区', value: '请选择', placeholder: '' },
        bankSubName: { label: '开户行名称', value: '请选择', sbno: '', placeholder: '' },
        accountLicense: { label: '开户许可证(选填)', value: '', placeholder: '' },
      },
      registerData: {
        loginNumber: { label: '登录账号', value: '', placeholder: '请输入登录账号' },
        verificationCode: { label: '验证码', value: '', placeholder: '请输入验证码' },
        registerPassword1: { label: '登录密码', value: '', placeholder: '登录密码(6位以上数字或字母)' },
        registerPassword2: { label: '再输一次', value: '', placeholder: '确认登录密码' },
        invitationCode: { label: '邀请码', value: '', code: '', placeholder: '请输入邀请码' },
      },
      popup: {
        title: '',
        parent: '',
        visible: false,
        type: 1,
        searchKey: '',
        searchSubKey: '',
        petNameArr: [{ id: '1', label: '类型', value: 1, selected: true }],
        accountTypeArr: [
          { id: '1', label: '企业', value: 1, selected: true },
          { id: '2', label: '个人', value: 2, selected: false },
        ],
        bankNameArr: [],
        bankAreaArr: [],
        bankAreaCityArr: [],
        bankSubNameArr: [],
      },
      areaPop: {
        visible: false,
        areaSlots: [
          { flex: 1, values: [], className: 'slot1', textAlign: 'center' },
          { flex: 1, values: [], className: 'slot2', textAlign: 'center' },
        ],
      },
      agreementPop: {
        visible: false,
        text: PUBLIC_AGREEMENT_TEXT,
      },
      tmp: {
        timing: null,
        bankAreaCity: '',
        configGetIsNeedInviteCode: '',
        pwd1Svg: 'hide_money',
        pwd1Type: 'password',
        pwd2Svg: 'hide_money',
        pwd2Type: 'password',
        checkBoxSvg: 'selected_coupons',
        checkBoxState: true,
        invitationTextDisabled: true,
        verificationBtnDisabled: false,
        appName: PUBLIC_APP_NAME,
        isFromQrCode: true,
        verificationBtnText: '获取验证码',
        selectedProvince: {
          id: '',
          value: '',
        },
        selectedCity: {
          id: '',
          value: '',
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.setCurrentPageState();
      this.currentTabIndex = 0;
      this.tabStatus.selected = [true, false, false];
      this.tabStatus.edited = [true, false, false];
      this.tabStatus.completed = [false, false, false];
      const pwn = PUBLIC_WELCOME_NAME; /*global  PUBLIC_WELCOME_NAME*/
      const pwc = PUBLIC_WELCOME_CODE; /*global  PUBLIC_WELCOME_CODE*/
      this.registerData.invitationCode.value = pwn || pwc;
      this.registerData.invitationCode.code = pwc;
      if (!this.registerData.invitationCode.code) {
        this.tmp.invitationTextDisabled = false;
      }
      CusLoadingOpen();
      this.getToken(() => {
        this.getConfig(() => {
          this.getProvinceCityAreaList(0, 0);
        });
      });
    });
  },
  watch: {
    popupSearchKey(newVal) {
      if (!newVal) {
        let cityArr = null;
        switch (this.popup.parent) {
          case 'bankName':
            this.popup.bankNameArr = [];
            this.getAllBankName(this.accountData.bankName.value);
            break;
          case 'bankArea':
            this.popup.bankAreaArr = [];
            this.getBankProvinceName(this.accountData.bankName.value, this.accountData.bankArea.value.split(' ')[0]);
            break;
          case 'bankSubName':
            this.popup.bankSubNameArr = [];
            cityArr = this.accountData.bankArea.value.split(' ');
            this.getBankName(this.accountData.bankName.value, cityArr[0], cityArr[1], this.accountData.bankSubName.value);
            break;
        }
      }
    },
    popupSearchSubKey(newVal) {
      if (!newVal) {
        switch (this.popup.parent) {
          case 'bankAreaProvince':
            this.popup.bankAreaCityArr = [];
            this.getBankCityName(this.accountData.bankName.value, this.tmp.bankAreaCity, this.accountData.bankArea.value.split(' ')[1]);
            break;
        }
      }
    },
    selectedProvinceId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getProvinceCityAreaList(1, newVal, () => {
          CusLoadingClose();
        });
      }
    },
  },
  computed: {
    customScrollHeight() {
      return `height:${window.innerHeight}px;`;
    },
    popupSearchKey() {
      return this.popup.searchKey;
    },
    popupSearchSubKey() {
      return this.popup.searchSubKey;
    },
    selectedProvinceId() {
      return this.tmp.selectedProvince.id;
    },
    selectedCityId() {
      return this.tmp.selectedCity.id;
    },
    hasNameAgreementText() {
      return this.agreementPop.text.replace(/tmpCustomAppName/g, this.tmp.appName);
    },
  },
  methods: {
    // 调用接口，获得token （代理商使用）
    getToken(callback = null) {
      GetTokenByDls()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              PUBLIC_TOKEN = res.data.token;
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 调用接口，获得Config （代理商使用）
    getConfig(callback = null) {
      // 2020.11.6 添加获取config配置信息 （代理商使用）
      GetConfigByDls()
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.tmp.configGetIsNeedInviteCode = res.data.needWelcomeCode;
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口根据银行卡号返回清算行信息
    getSBNOByCardNumWithoutLogin(number) {
      GetSBNOByCardNumWithoutLogin({ bankCardNum: number, repeatCheck: 1 })
        .then(res => {
          SucceedHandle2(res.code, res.msg, () => {
            this.accountData.bankName.value = res.data.bankName;
          });
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口根据银行卡号返回清算行信息2
    getSBNOByCardNumWithoutLoginByBtn(number, callBack = null) {
      GetSBNOByCardNumWithoutLogin({ bankCardNum: number, repeatCheck: 1 })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              callBack && callBack();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取银行卡对应银行名
    getAllBankName(selectedValue = '') {
      CusLoadingOpen();
      GetAllBankName()
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                res.rows.forEach(item => {
                  this.popup.bankNameArr.push({
                    label: item.bankName.replace('&', ''),
                    value: '',
                    selected: item.bankName === selectedValue,
                  });
                });
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取银行卡地区信息
    getBankProvinceName(bankName, selectedValue = '') {
      CusLoadingOpen();
      GetBankProvinceName({ bankName })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                res.rows.forEach(item => {
                  this.popup.bankAreaArr.push({
                    label: item.provinceName,
                    value: item.provinceId,
                    selected: item.provinceName === selectedValue,
                  });
                });
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取银行卡地区城市信息
    getBankCityName(bankName, provinceName, selectedValue = '') {
      CusLoadingOpen();
      GetBankCityName({ bankName, provinceName })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                res.rows.forEach(item => {
                  this.popup.bankAreaCityArr.push({
                    label: item.cityName,
                    selected: item.cityName === selectedValue,
                  });
                });
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取银行卡开户行信息
    getBankName(bankName, provinceName, cityName, selectedValue = '') {
      CusLoadingOpen();
      GetBankName({ bankName, provinceName, cityName })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                res.rows.forEach(item => {
                  this.popup.bankSubNameArr.push({
                    label: item.bankAllName,
                    value: item.sbno,
                    selected: item.bankAllName === selectedValue,
                  });
                });
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口返回省/市/区
    getProvinceCityAreaList(index = 0, id = 0, callback = null) {
      GetAreaList({ parent_id: id })
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res.rows && res.rows.length > 0) {
                this.areaPop.areaSlots[index].values = [];
                res.rows.forEach(item => {
                  this.areaPop.areaSlots[index].values.push({
                    label: item.area_name,
                    value: item.id,
                  });
                });
              }
              callback && callback();
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取身份证正反面信息
    getIdCardInformation(imgUrl, side) {
      CusLoadingOpen();
      GetIdCardInformation({ imgUrl, side })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              if (res && res.data) {
                if (side === 1) {
                  this.baseData.idCardName.value = res.data.name;
                  this.baseData.idCardNo.value = res.data.idCardNum;
                }
              }
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取营业执照信息
    getBusinessLicenseInfo(imgUrl) {
      CusLoadingOpen();
      GetBusinessLicenseInfo({ imgUrl })
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.baseData.businessLicenseNo.value = res.data.ocrBusinessLicenseNum;
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口获取注册码
    getSMSCode(data) {
      GetSMSCode(data)
        .then(res => {
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.tmp.invitationTextDisabled = true;
              this.tmp.verificationBtnDisabled = true;
              let time = 60;
              const sendSms = function () {
                if (time > 0) {
                  this.tmp.verificationBtnText = time + '秒后重新获取';
                  time -= 1;
                } else {
                  this.endTiming();
                }
                return sendSms;
              }.bind(this);
              this.tmp.timing = setInterval(sendSms(), 1000);
            },
            (code, msg) => {
              // 2020.11.6添加，未获得邀请资质时，提示是否继续
              // 如果继续则清空邀请码并重新调用获取邀请码接口
              if (code === 9073) {
                CusConfirm('尚未获得邀请资质', () => {
                  this.registerData.invitationCode.value = '';
                  this.onGetVerificationCodeClick();
                });
              } else {
                msg && CusToast(msg);
              }
            }
          );
        })
        .catch(err => {
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 通过接口注册代理商
    agentRegister() {
      CusLoadingOpen();
      const data = {
        accountCard: this.accountData.accountNo.value.replace(/\s/gi, ''),
        accountName: this.accountData.accountName.value,
        address: this.baseData.baseAddress.value,
        bankName: this.accountData.bankName.value,
        bankSbNo: this.accountData.bankSubName.sbno,
        branchBankName: this.accountData.bankSubName.value,
        cardAccountType: this.accountData.accountType.id,
        cardCity: this.accountData.bankArea.value.split(' ')[1],
        cardProvince: this.accountData.bankArea.value.split(' ')[0],
        city: this.baseData.baseCity.value,
        code: this.registerData.verificationCode.value,
        email: this.baseData.baseEmail.value,
        inviteCode: this.registerData.invitationCode.code || this.registerData.invitationCode.value.replace(/\s/gi, ''),
        legalID: this.baseData.idCardNo.value.replace(/\s/gi, ''),
        legalIDUrl: [this.baseData.idCardFront.value, this.baseData.idCardBack.value],
        legalPerson: this.baseData.idCardName.value,
        licenseNo: this.baseData.businessLicenseNo.value,
        licenseUrl: [this.baseData.businessLicense.value],
        mobile: this.baseData.agentMobile.value.replace(/\s/gi, ''),
        name: this.baseData.agentName.value,
        nickNameId: this.baseData.petName.id,
        openAccountUrl: this.accountData.accountLicense.value ? [this.accountData.accountLicense.value] : [],
        province: this.baseData.baseProvince.value,
        pwd: this.registerData.registerPassword1.value,
        taxNo: this.baseData.taxRegisterNo.value,
      };
      AgentRegister(data)
        .then(res => {
          CusLoadingClose();
          SucceedHandle2(
            res.code,
            res.msg,
            () => {
              this.handleAddUserSuccess('注册成功');
            },
            (code, msg) => {
              msg && CusToast(msg);
            }
          );
        })
        .catch(err => {
          CusLoadingClose();
          const msg = NotSucceedHandle(err.message);
          msg && CusToast(msg);
        });
    },
    // 结束倒计时
    endTiming() {
      clearInterval(this.tmp.timing);
      this.tmp.verificationBtnDisabled = false;
      this.tmp.verificationBtnText = '获取验证码';
    },
    // 验证当前页面数据的合法性
    validatePageData(pageIndex, callback = null) {
      // 验证-基本
      if (pageIndex === 0) {
        // 验证
        const agentNameErr = validateEmpty(this.baseData.agentName.value);
        const agentMobileErr = validateMobile(this.baseData.agentMobile.value);
        const idCardFrontErr = validateEmpty(this.baseData.idCardFront.value);
        const idCardBackErr = validateEmpty(this.baseData.idCardBack.value);
        const idCardNameErr = validateEmpty(this.baseData.idCardName.value);
        const idCardNoErr = validateIdCard(this.baseData.idCardNo.value);
        const businessLicenseErr = validateEmpty(this.baseData.businessLicense.value);
        const businessLicenseNoErr = validateLicenseNo2(this.baseData.businessLicenseNo.value);
        const baseProvinceErr = validateEmpty(this.baseData.baseProvince.value);
        const baseCityErr = validateEmpty(this.baseData.baseCity.value);
        const baseAddressErr = validateEmpty(this.baseData.baseAddress.value);

        const errResult1 = !agentNameErr && !agentMobileErr && !idCardFrontErr;
        const errResult2 = !idCardBackErr && !idCardNameErr && !idCardNoErr;
        const errResult3 = !businessLicenseErr && !businessLicenseNoErr;
        const errResult4 = !baseProvinceErr && !baseCityErr && !baseAddressErr;

        if (errResult1 && errResult2 && errResult3 && errResult4) {
          callback && callback();
        } else {
          if (agentNameErr === 1) {
            CusToast('代理商名称不能为空');
            return;
          }
          if (agentMobileErr === 1) {
            CusToast('代理商手机号不能为空');
            return;
          }
          if (agentMobileErr === 2) {
            CusToast('代理商手机号格式不正确');
            return;
          }
          if (idCardFrontErr === 1) {
            CusToast('证件照头像面不能为空');
            return;
          }
          if (idCardBackErr === 1) {
            CusToast('证件照国徽面不能为空');
            return;
          }
          if (idCardNameErr === 1) {
            CusToast('法人姓名不能为空');
            return;
          }
          if (idCardNoErr === 1) {
            CusToast('法人身份证号不能为空');
            return;
          }
          if (idCardNoErr === 2) {
            CusToast('法人身份证号格式不正确');
            return;
          }
          if (businessLicenseErr === 1) {
            CusToast('营业执照照片不能为空');
            return;
          }
          if (businessLicenseNoErr === 1) {
            CusToast('营业执照号不能为空');
            return;
          }
          if (businessLicenseNoErr === 2) {
            CusToast('营业执照号格式错误');
            return;
          }
          if (baseProvinceErr === 1) {
            CusToast('所在省份不能为空');
            return;
          }
          if (baseCityErr === 1) {
            CusToast('所在城市不能为空');
            return;
          }
          if (baseAddressErr === 1) {
            CusToast('联系地址不能为空');
            return;
          }
        }
      }
      // 验证-结算卡
      if (pageIndex === 1) {
        // 验证
        const accountNameErr = validateEmpty(this.accountData.accountName.value);
        const accountNoErr = validateBankCardPublic(this.accountData.accountNo.value);
        const bankNameErr = validateEmpty(this.accountData.bankName.value);
        const bankAreaErr = validateEmpty(this.accountData.bankArea.value);
        const bankSubNameErr = validateEmpty(this.accountData.bankSubName.value);

        const errResult1 = !accountNameErr && !accountNoErr;
        const errResult2 = !bankNameErr && !bankAreaErr && !bankSubNameErr;

        if (errResult1 && errResult2) {
          callback && callback();
        } else {
          if (accountNameErr === 1) {
            CusToast('开户名不能为空');
            return;
          }
          if (accountNoErr === 1) {
            CusToast('开户行账号不能为空');
            return;
          }
          if (accountNoErr === 2) {
            CusToast('开户行账号长度必须在9到20之间');
            return;
          }
          if (accountNoErr === 3) {
            CusToast('开户行账号开头6位不符合规范');
            return;
          }
          if (bankNameErr === 1) {
            CusToast('银行名称不能为空');
            return;
          }
          if (bankAreaErr === 1) {
            CusToast('开户地区不能为空');
            return;
          }
          if (bankSubNameErr === 1) {
            CusToast('开户行名称不能为空');
            return;
          }
        }
      }
      // 验证-注册
      if (pageIndex === 2) {
        // 验证
        const loginNumberErr = validateMobile(this.registerData.loginNumber.value);
        const verificationCodeErr = validateEmpty(this.registerData.verificationCode.value);
        const registerPassword1Err = validatePassword(this.registerData.registerPassword1.value);
        const registerPassword2Err = this.registerData.registerPassword2.value === this.registerData.registerPassword1.value ? 0 : 1;
        const invitationCodeErr = validateMobile(this.registerData.invitationCode.value);

        const errResult1 = !loginNumberErr && !verificationCodeErr && !registerPassword1Err && !registerPassword2Err;
        const errResult2 = !this.registerData.invitationCode.code ? !invitationCodeErr : true;

        if (errResult1 && errResult2) {
          callback && callback();
        } else {
          if (loginNumberErr === 1) {
            CusToast('登录账号不能为空');
            return;
          }
          if (loginNumberErr === 2) {
            CusToast('登录账号格式不正确');
            return;
          }
          if (verificationCodeErr === 1) {
            CusToast('验证码不能为空');
            return;
          }
          if (registerPassword1Err === 1) {
            CusToast('登录密码不能为空');
            return;
          }
          if (registerPassword1Err === 2) {
            CusToast('登录密码为6位以上数字或字母');
            return;
          }
          if (registerPassword1Err === 3) {
            CusToast('登录密码不能是重复的数字');
            return;
          }
          if (registerPassword1Err === 4) {
            CusToast('密码不能是连续的数字');
            return;
          }
          if (registerPassword2Err === 1) {
            CusToast('两次密码输入的不一致');
            return;
          }
          if (!this.registerData.invitationCode.code) {
            if (invitationCodeErr === 1) {
              CusToast('邀请码不能为空');
              return;
            }
            if (invitationCodeErr === 2) {
              CusToast('邀请码格式不正确');
              return;
            }
          }
        }
      }
    },
    // 设置topbar选中状态
    setTabSelectedStatus(index) {
      // 设置topbar选中样式
      this.tabStatus.selected = this.tabStatus.selected.map(item => (item = false));
      this.tabStatus.selected[index] = true;
      this.currentTabIndex = index;
    },
    setCurrentPageState() {
      // 判断入口路径
      if (PUBLIC_WELCOME_QRCODE === '') {
        this.tmp.isFromQrCode = true;
      } else if (PUBLIC_WELCOME_QRCODE === '0' || PUBLIC_WELCOME_QRCODE === false) {
        this.tmp.isFromQrCode = false;
      } else {
        this.tmp.isFromQrCode = true;
      }
    },
    // 返回的图片信息
    getCameraImgInfo(info) {
      upLoadImgForAgent(info.blob, info.base64, info.type, res => {
        switch (info.type) {
          case 'renXiang':
            this.baseData.idCardFront.value = res.data;
            this.getIdCardInformation(res.data, 1);
            break;
          case 'guoHui':
            this.baseData.idCardBack.value = res.data;
            this.getIdCardInformation(res.data, 2);
            break;
          case 'businessLicense':
            this.baseData.businessLicense.value = res.data;
            this.getBusinessLicenseInfo(res.data);
            break;
          case 'accountLicense':
            this.accountData.accountLicense.value = res.data;
            break;
        }
      });
    },
    // 顶部tab点击事件
    onTabClick(index) {
      this.$nextTick(() => {
        // 先判断不能选中当前已经选定的页面
        if (!this.tabStatus.selected[index]) {
          // 再判断要选中的页面是否可以编辑，不可编辑不能选中
          if (this.tabStatus.edited[index]) {
            // 最后在切换当前tab之前，对当前页面数据数据进行验证
            if (this.tabStatus.completed[this.currentTabIndex]) {
              this.validatePageData(this.currentTabIndex, () => {
                this.setTabSelectedStatus(index);
              });
            } else {
              this.setTabSelectedStatus(index);
            }
          } else {
            CusToast('请完善当前页面信息');
          }
        }
      });
    },
    // 基本信息-手机号输入事件
    onAgentMobileInput() {
      this.baseData.agentMobile.value = controlMobileInput(this.baseData.agentMobile.value);
      this.registerData.loginNumber.value = this.baseData.agentMobile.value;
    },
    // 基本信息-法人身份证输入事件
    onIdCardNoInput() {
      this.baseData.idCardNo.value = controlIdCardInput(this.baseData.idCardNo.value);
    },
    // 基本信息-营业执照号输入事件
    onBusinessLicenseNoInput() {
      this.baseData.businessLicenseNo.value = controlLicenseNoInput(this.baseData.businessLicenseNo.value);
    },
    // 基本信息-所在省份城市地区点击事件
    onBaseProvinceCItyClick() {
      this.areaPop.visible = true;
    },
    // 基本信息-昵称点击事件
    onPetNameClick() {
      if (this.baseData.petName.mult) {
        this.popup.type = 1;
        this.popup.title = '选择昵称';
        this.popup.parent = 'petName';
      }
      this.$nextTick(() => {
        this.popup.visible = true;
      });
    },
    // 账户信息-开户类型点击事件
    onAccountTypeClick() {
      if (this.accountData.accountType.mult) {
        this.popup.type = 1;
        this.popup.title = '开户类型';
        this.popup.parent = 'accountType';
        this.$nextTick(() => {
          this.popup.visible = true;
        });
      }
    },
    // 账户信息-开户行账号输入事件
    onAccountNoInput() {
      this.$nextTick(() => {
        this.accountData.accountNo.value = controlBankCardInput(this.accountData.accountNo.value);
        const currentNumber = this.accountData.accountNo.value.replace(/\s/gi, '');
        if (currentNumber.length === 9 || currentNumber.length === 20) {
          this.getSBNOByCardNumWithoutLogin(currentNumber);
        }
      });
    },
    // 账户信息-所属银行点击事件
    onBankNameClick() {
      this.popup.title = '所属银行';
      this.popup.parent = 'bankName';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.bankNameArr = [];
      this.getAllBankName(this.accountData.bankName.value);
    },
    // 账户信息-开户地区点击事件
    onBankAreaClick() {
      if (!this.accountData.bankName.value === '请选择') {
        CusToast('请先选择所属银行');
        return;
      }
      this.popup.title = '开户地区';
      this.popup.parent = 'bankArea';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.bankAreaArr = [];
      this.getBankProvinceName(this.accountData.bankName.value, this.accountData.bankArea.value.split(' ')[0]);
    },
    // 账户信息-开户支行点击事件
    onBankSubNameClick() {
      if (!this.accountData.bankName.value === '请选择') {
        CusToast('请先选择所属银行');
        return;
      }
      const cityArr = this.accountData.bankArea.value.split(' ');
      if (!cityArr[0] || !cityArr[1]) {
        CusToast('请先选择开户地区');
        return;
      }
      this.popup.title = '开户行';
      this.popup.parent = 'bankSubName';
      this.popup.visible = true;
      this.popup.type = 2;
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.bankSubNameArr = [];
      this.getBankName(this.accountData.bankName.value, cityArr[0], cityArr[1], this.accountData.bankSubName.value);
    },
    // 注册信息-手机号输入事件
    onLoginNumberInput() {
      this.registerData.loginNumber.value = controlMobileInput(this.registerData.loginNumber.value);
    },
    // 注册信息-验证码输入事件
    onVerificationCodeInput() {
      this.registerData.verificationCode.value = controlMoneyInput(this.registerData.verificationCode.value);
    },
    // 注册信息-密码1输入事件
    onRegisterPassword1Input() {
      this.registerData.registerPassword1.value = controlLicenseNoInput(this.registerData.registerPassword1.value);
    },
    // 注册信息-密码2输入事件
    onRegisterPassword2Input() {
      this.registerData.registerPassword2.value = controlLicenseNoInput(this.registerData.registerPassword2.value);
    },
    // 注册信息-邀请码输入事件
    onInvitationCodeInput() {
      this.registerData.invitationCode.value = controlMobileInput(this.registerData.invitationCode.value);
    },
    // 基本信息-点击提交事件
    onBaseInfoSubmitClick() {
      this.$nextTick(() => {
        this.validatePageData(0, () => {
          // 设置page的完成状态
          this.tabStatus.completed[0] = true;
          // 设置page的编辑状态
          this.tabStatus.edited[1] = true;
          // 设置topbar选中样式
          this.setTabSelectedStatus(1);
          this.registerData.loginNumber.value = this.baseData.agentMobile.value;
        });
      });
    },
    // 账户信息-点击提交事件
    onAccountInfoSubmitClick() {
      this.$nextTick(() => {
        this.validatePageData(1, () => {
          const number = this.accountData.accountNo.value.replace(/\s/gi, '');
          this.getSBNOByCardNumWithoutLoginByBtn(number, () => {
            // 设置page的完成状态
            this.tabStatus.completed[1] = true;
            // 设置page的编辑状态
            this.tabStatus.edited[2] = true;
            // 设置topbar选中样式
            this.setTabSelectedStatus(2);
          });
        });
      });
    },
    // 注册信息-点击提交事件
    onRegisterInfoSubmitClick() {
      this.$nextTick(() => {
        if (!this.tmp.checkBoxState) {
          CusToast('请勾选同意《注册协议》');
          return;
        }
        this.validatePageData(2, () => {
          // 设置page的完成状态
          this.tabStatus.completed[2] = true;
          this.agentRegister();
        });
      });
    },
    // 昵称的单击事件
    onIncentiveModelItemClick() {},
    // 开户类型的单击事件
    onAccountTypeItemClick(item) {
      this.popup.accountTypeArr.forEach(item => (item.selected = false));
      item.selected = true;
    },
    // 所属银行备选项的单击事件
    onPopupBankNameItemClick(item) {
      this.popup.bankNameArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 2) {
        this.accountData.bankName.value = item.label;
        this.accountData.bankArea.value = '请选择';
        this.accountData.bankSubName.value = '请选择';
        this.accountData.bankSubName.sbno = '';
        this.popup.visible = false;
      }
    },
    // 所属银行地区备选项的单击事件
    onPopupBankAreaItemClick(item) {
      this.popup.bankAreaArr.forEach(item => (item.selected = false));
      item.selected = true;
      this.popup.type = 3;
      this.popup.title = '开户地区';
      this.popup.parent = 'bankAreaProvince';
      this.popup.searchKey = '';
      this.popup.searchSubKey = '';
      this.popup.bankAreaCityArr = [];
      this.tmp.bankAreaCity = item.label;
      this.getBankCityName(this.accountData.bankName.value, item.label, this.accountData.bankArea.value.split(' ')[1]);
    },
    // 所属银行开户行备选项的单击事件
    onPopupBankSubNameItemClick(item) {
      this.popup.bankSubNameArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 2) {
        this.accountData.bankSubName.value = item.label;
        this.accountData.bankSubName.sbno = item.value;
        this.popup.visible = false;
      }
    },
    // 所属银行地区城市备选项的单击事件
    onPopupBankAreaCityItemClick(item) {
      this.popup.bankAreaCityArr.forEach(item => (item.selected = false));
      item.selected = true;
      if (this.popup.type === 3) {
        this.accountData.bankArea.value = `${this.tmp.bankAreaCity} ${item.label}`;
        this.accountData.bankSubName.value = '请选择';
        this.accountData.bankSubName.sbno = '';
        this.popup.visible = false;
      }
    },
    // popup 窗口返回单击事件
    onPopupBackBtnClick() {
      this.popup.visible = false;
    },
    // 备选项弹窗的查询keyup事件
    onPopupSearchKeyup() {
      switch (this.popup.parent) {
        case 'bankName':
          this.popup.bankNameArr = this.popup.bankNameArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
        case 'bankArea':
          this.popup.bankAreaArr = this.popup.bankAreaArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
        case 'bankSubName':
          this.popup.bankSubNameArr = this.popup.bankSubNameArr.filter(item => {
            return item.label.indexOf(this.popup.searchKey) > -1;
          });
          break;
      }
      document.activeElement.blur();
    },
    // 备选项二级弹窗的查询keyup事件
    onPopupSearchSubKeyup() {
      switch (this.popup.parent) {
        case 'bankAreaProvince':
          this.popup.bankAreaCityArr = this.popup.bankAreaCityArr.filter(item => {
            return item.label.indexOf(this.popup.searchSubKey) > -1;
          });
          break;
      }
      document.activeElement.blur();
    },
    // 选中确定成功的单击事件
    onPopupSuccessBtnClick() {
      if (this.popup.parent === 'businessLicenseType') {
        for (let i = 0; i < this.popup.businessLicenseTypeArr.length; i++) {
          if (this.popup.businessLicenseTypeArr[i].selected) {
            this.companyData.businessLicenseType.value = this.popup.businessLicenseTypeArr[i].label;
            this.companyData.businessLicenseType.id = this.popup.businessLicenseTypeArr[i].value;
            break;
          }
        }
      }
      if (this.popup.parent === 'bankCardType') {
        for (let i = 0; i < this.popup.bankCardTypeArr.length; i++) {
          if (this.popup.bankCardTypeArr[i].selected) {
            this.bankCardData.bankCardType.value = this.popup.bankCardTypeArr[i].label;
            this.bankCardData.bankCardType.id = this.popup.bankCardTypeArr[i].value;
            break;
          }
        }
      }
      if (this.popup.parent === 'agreementType') {
        for (let i = 0; i < this.popup.agreementTypeArr.length; i++) {
          if (this.popup.agreementTypeArr[i].selected) {
            this.commitmentData.agreementType.value = this.popup.agreementTypeArr[i].label;
            this.commitmentData.agreementType.id = this.popup.agreementTypeArr[i].value;
            break;
          }
        }
      }
      this.$nextTick(() => {
        this.popup.visible = false;
      });
    },
    // 地区选择控件选中事件
    onAreaPopChange(picker) {
      this.$nextTick(() => {
        this.tmp.selectedProvince.id = picker.getSlotValue(0) ? picker.getSlotValue(0).value : '';
        this.tmp.selectedProvince.value = picker.getSlotValue(0) ? picker.getSlotValue(0).label : '';
        this.tmp.selectedCity.id = picker.getSlotValue(1) ? picker.getSlotValue(1).value : '';
        this.tmp.selectedCity.value = picker.getSlotValue(1) ? picker.getSlotValue(1).label : '';
      });
    },
    // 地区选择控件确定按钮事件
    onAreaPopupSuccessClick() {
      this.baseData.baseProvince.id = this.tmp.selectedProvince.id;
      this.baseData.baseProvince.value = this.tmp.selectedProvince.value;
      this.baseData.baseCity.id = this.tmp.selectedCity.id;
      this.baseData.baseCity.value = this.tmp.selectedCity.value;
      this.areaPop.visible = false;
    },
    // 获取验证码按钮点击事件
    onGetVerificationCodeClick() {
      if (this.tmp.verificationBtnDisabled) return;
      // 2020.8.28新加，如果url传入的邀请码不存在，则认为允许客户输入邀请码
      // 允许客户输入邀请码时先校验邀请码
      // 再获取格式正确的邀请码
      const loginNumberErr = validateMobile(this.registerData.loginNumber.value);
      if (loginNumberErr === 1) {
        CusToast('登录账号不能为空');
        return;
      }
      if (loginNumberErr === 2) {
        CusToast('登录账号格式不正确');
        return;
      }
      if (!this.registerData.invitationCode.code) {
        const invitationCodeErr = validateMobile(this.registerData.invitationCode.value);
        if (invitationCodeErr === 1) {
          CusToast('邀请码不能为空');
          return;
        }
        if (invitationCodeErr === 2) {
          CusToast('邀请码格式不正确');
          return;
        }
      }
      this.getSMSCode({
        flag: 1,
        inviteCode: this.registerData.invitationCode.code || this.registerData.invitationCode.value.replace(/\s/gi, ''),
        mobile: this.registerData.loginNumber.value.replace(/\s/gi, ''),
      });
    },
    // 登录密码眼睛1按钮点击事件
    onPwd1EyeClick() {
      if (this.tmp.pwd1Svg === 'hide_money') {
        this.tmp.pwd1Svg = 'show_money';
        this.tmp.pwd1Type = 'text';
      } else {
        this.tmp.pwd1Svg = 'hide_money';
        this.tmp.pwd1Type = 'password';
      }
    },
    //  登录密码眼睛2按钮点击事件
    onPwd2EyeClick() {
      if (this.tmp.pwd2Svg === 'hide_money') {
        this.tmp.pwd2Svg = 'show_money';
        this.tmp.pwd2Type = 'text';
      } else {
        this.tmp.pwd2Svg = 'hide_money';
        this.tmp.pwd2Type = 'password';
      }
    },
    // 同意协议checkbox的change
    onCheckClick() {
      this.tmp.checkBoxState = !this.tmp.checkBoxState;
      this.tmp.checkBoxSvg = this.tmp.checkBoxState ? 'selected_coupons' : 'unselected_coupons';
    },
    // 缓存页面信息
    onToAgreementClick() {
      this.agreementPop.visible = true;
    },
    // 处理添加用户成功事件
    handleAddUserSuccess(msg) {
      // 判断是否是扫二维码进到此页面
      if (this.tmp.isFromQrCode) {
        // 是，则注册成功后跳转APP下载页面
        const key = PUBLIC_PRODUCT.toLowerCase().trim();
        switch (PUBLIC_SYSTEM_FLAG) {
          case 'android':
            if (android_download_url[key]) {
              if (Array.isArray(android_download_url[key])) {
                switch (android_download_url[key].length) {
                  case 1:
                    if (android_download_url[key][0].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                  case 2:
                    if (android_download_url[key][0].url && android_download_url[key][1].url) {
                      this.$router.push('/download');
                    } else CusToast(msg);
                    break;
                }
              } else {
                CusToast(msg);
              }
            } else {
              CusToast(msg);
            }
            break;
          case 'ios':
            if (ios_download_url[key]) {
              if (Array.isArray(ios_download_url[key])) {
                switch (ios_download_url[key].length) {
                  case 1:
                    if (ios_download_url[key][0].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                  case 2:
                    if (ios_download_url[key][0].url && ios_download_url[key][1].url) this.$router.push('/download');
                    else CusToast(msg);
                    break;
                }
              } else {
                CusToast(msg);
              }
            } else {
              CusToast(msg);
            }
            break;
        }
      } else {
        // 反之，则注册成功后发请求到APP，APP去处理下一步如何进行
        CusToast(msg);
        window.location.href = 'registerok://android';
      }
    },
  },
};
</script>

<style scoped>
.rate-text {
  text-align: right;
  padding-right: 0.6rem !important;
}
.current-tab {
  width: 33% !important;
  margin-left: 1.1rem !important;
  margin-right: 1.1rem !important;
}
.short-input {
  width: 50% !important;
}
.current-padding-top {
  padding-top: 0 !important;
}
.tab-menu {
  top: 0;
}
.current-agreement-btn {
  margin: 0 auto;
}
</style>
